import React from 'react';

import { Select, normalizeSelectValue } from '@gogame/components';
import { withFormField, omitFormProps } from '@gogame/form';

const normalizeValue = (value, options) => {
  if (options.length === 1) {
    return options[0].id;
  }
  return normalizeSelectValue(value, options);
};

export const SecondaryAffectedLevel = withFormField({ normalizeValue })(
  ({ area, ...props }) => {
    const [show, setShow] = React.useState(true);

    React.useEffect(() => {
      if (area.data) {
        setShow(Boolean(area.data?.length));
      }
    }, [area.data]);

    if (!show) {
      return null;
    }

    return (
      <Select
        loading={area.loading}
        options={area.data}
        {...omitFormProps(props)}
      />
    );
  }
);
